import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _extends from 'babel-runtime/helpers/extends';
import PropTypes from '../_util/vue-types';
import BaseMixin from '../_util/BaseMixin';
import SelectFilter from '../cascader/SelectFilter';
import CascaderProps from '../cascader/CascaderPropTypes';
import MenuItem from './MenuItem';
import { throttle } from 'lodash';
import { getOffsetTop } from '../cascader/util';
import scrollTo from '../_util/scrollTo';

var Menus = {
  mixins: [BaseMixin],
  props: _extends({}, CascaderProps, {
    activeValue: PropTypes.array.def([]),
    deep: PropTypes.number,
    maxDeep: PropTypes.number,
    treeNodes: PropTypes.array,
    prefixCls: PropTypes.string.def('rc-cascader-menu'),
    expandTrigger: PropTypes.string.def('click'),
    defaultFieldNames: PropTypes.object,
    visible: PropTypes.bool.def(false),
    menuColumnStyle: PropTypes.array,
    checkedKeys: PropTypes.array.def([]),
    halfCheckedKeys: PropTypes.array.def([]),
    selectorValueList: PropTypes.array.def([]),
    filteredTreeNodes: PropTypes.any,
    fastFinderOption: PropTypes.array
  }),
  inject: {
    Cascader: { 'default': function _default() {
        return {};
      } }
  },
  computed: {
    columnNameData: function columnNameData() {
      var data = [];
      for (var i = this.deep - 1; i >= 0; i--) {
        if (!this.columnNames || !this.columnNames[i]) continue;
        var tmp = { value: 'title_' + i, label: this.columnNames[i], level: i };
        if (data.length) {
          data = [_extends({}, tmp, { children: data })];
        } else {
          data = [tmp];
        }
      }
      return data;
    }
  },
  mounted: function mounted() {
    if (this.$refs.menuWrapper) {
      this.$refs.menuWrapper.$el.querySelector('.ways-cascader-table-menu_scroll').addEventListener('scroll', this.handleScroll);
    }
  },
  destoryed: function destoryed() {
    if (this.$refs.menuWrapper) {
      this.$refs.menuWrapper.$el.querySelector('.ways-cascader-table-menu_scroll').removeEventListener('scroll', this.handleScroll);
    }
  },

  methods: {
    handleFastFinderChange: function handleFastFinderChange(value) {
      var _this = this;

      var callbackFn = function callbackFn() {
        var container = _this.$refs.menuWrapper.$el.querySelector('.ways-cascader-table-menu_scroll');
        var target = container.querySelector('#scroll-key-' + value);
        var offsetTop = getOffsetTop(target, container);
        var y = container.scrollTop + offsetTop;
        scrollTo(y, {
          getContainer: function getContainer() {
            return container;
          }
        });
      };
      this.Cascader.onFastFinderChange(value, callbackFn);
    },
    getMenuItemRef: function getMenuItemRef(index) {
      return 'menuItems_' + index;
    },
    renderNotFound: function renderNotFound() {
      var h = this.$createElement;
      var $scopedSlots = this.$scopedSlots;
      var _$props = this.$props,
          prefixCls = _$props.prefixCls,
          height = _$props.height,
          showGroup = _$props.showGroup,
          showFilter = _$props.showFilter,
          notFoundContent = _$props.notFoundContent;

      var showFilterFinal = showFilter && (showGroup || $scopedSlots.filter());
      return h(
        'span',
        {
          'class': prefixCls + '-not-found',
          style: { height: height ? height - (showFilterFinal ? 48 : 0) + 'px' : null }
        },
        [notFoundContent]
      );
    },


    handleScroll: throttle(function (_ref) {
      var _ref$target = _ref.target,
          scrollTop = _ref$target.scrollTop,
          scrollHeight = _ref$target.scrollHeight;
      var height = this.$props.height;

      var containerHeight = Number(height);
      var scrollToBottom = scrollTop + containerHeight - scrollHeight >= 0;
      this.__emit('scroll', { scrollToBottom: scrollToBottom });
    }, 300)
  },
  render: function render() {
    var h = arguments[0];
    var props = this.$props,
        $scopedSlots = this.$scopedSlots;
    var prefixCls = props.prefixCls,
        height = props.height,
        showGroup = props.showGroup,
        fastFinderPos = props.fastFinderPos,
        treeNodes = props.treeNodes,
        filteredTreeNodes = props.filteredTreeNodes;
    var columnNameData = this.columnNameData;


    var $notFound = void 0;
    var $treeNodes = void 0;
    if (filteredTreeNodes) {
      if (filteredTreeNodes.length) {
        $treeNodes = filteredTreeNodes;
      } else {
        $notFound = this.renderNotFound();
      }
    } else if (!treeNodes || !treeNodes.length) {
      $notFound = this.renderNotFound();
    } else {
      $treeNodes = treeNodes;
    }

    var Filter = null;
    var showFilter = showGroup && fastFinderPos === 'top' || $scopedSlots.filter();
    if (showFilter) {
      var filterProps = {
        props: _extends({}, props, {
          prefixCls: prefixCls + '-filter'
        }),
        on: {
          change: this.handleFastFinderChange
        },
        scopedSlots: {
          filter: $scopedSlots.filter
        }
      };
      Filter = h(SelectFilter, filterProps);
    }

    var $tree = null;
    if ($notFound) {
      $tree = h('div', [Filter, $notFound]);
    } else {
      var columnProps = {
        props: _extends({}, props, {
          isHeader: true,
          treeNodes: columnNameData
        }),
        'class': prefixCls + '-name'
      };

      var menuProps = {
        props: _extends({}, props, {
          treeNodes: $treeNodes,
          columnHeight: height ? height - (columnNameData.length > 0 && !showGroup ? 32 : 0) - (showFilter ? 48 : 0) : 0
        }),
        on: {
          change: this.handleFastFinderChange
        }
      };
      menuProps['class'] = prefixCls + '-wrapper';

      $tree = h('div', [Filter, columnNameData.length > 0 && h(MenuItem, columnProps), h(MenuItem, _mergeJSXProps([{ ref: 'menuWrapper' }, menuProps]))]);
    }

    return $tree;
  }
};

export default Menus;